<template>
    <div class="delivery-detail">
        <div class="delivery-detail_header">
            <img src="@/assets/images/training/delivery-detail-header.jpg" alt="" />
        </div>

        <div class="delivery-detail_result">
            <div class="result-icon">
                <img src="@/assets/icons/correct-icon.svg" alt="" />
                <span>投放完成</span>
            </div>

            <div class="result-desc">
                DOU+已完成对视频的加热
            </div>
        </div>

        <!-- 推广内容 -->
        <div class="delivery-detail_content delivery-item">
            <div class="content-header item-header">推广内容</div>

            <div class="content-video">
                <img :src="getImgSrc(videoData.img)" alt="" class="video-img" />

                <div class="video-info">
                    <div class="info-title">{{ videoData.title }}</div>

                    <div class="info-user">{{ videoData.user }}</div>
                </div>
            </div>

            <div class="content-detail" v-if="expandDetail">
                <div class="detail-item">
                    <div class="item-label">订单ID</div>
                    <div class="item-value">{{ videoData.order_no }}</div>
                </div>

                <div class="detail-item">
                    <div class="item-label">下单时间</div>
                    <div class="item-value">{{ getDateLabel }}</div>
                </div>

                <div class="detail-item">
                    <div class="item-label">订单金额</div>
                    <div class="item-value">￥{{ videoData.money }}</div>
                </div>

                <div class="detail-item">
                    <div class="item-label">预计投放时长</div>
                    <div class="item-value">{{ videoData.time }}</div>
                </div>

                <div class="detail-item">
                    <div class="item-label">投放目标</div>
                    <div class="item-value">{{ videoData.target }}</div>
                </div>

                <div class="detail-item">
                    <div class="item-label">定向方式</div>
                    <div class="item-value">{{ videoData.direction_method }}</div>
                </div>
            </div>

            <div class="content-expand">
                <div class="expand-button" @click="expandDetail = !expandDetail">
                    <span>{{ expandDetail ? "收起详情" : "展开详情" }}</span>

                    <i class="el-icon el-icon-arrow-up" v-if="expandDetail"></i>
                    <i class="el-icon el-icon-arrow-down" v-else></i>
                </div>
            </div>
        </div>

        <!-- 推广效果 -->
        <div class="delivery-detail_effect delivery-item">
            <div class="effect-header item-header">
                推广效果
                <i class="iconfont" @click="handleEffectInfo">&#xe603;</i>
            </div>

            <!-- 基础数据 -->
            <div class="effect-data">
                <div class="data-item">
                    <div class="item-label">
                        <i class="iconfont">&#xe905;</i>
                        <span>播放量</span>
                    </div>

                    <div class="item-value">{{ videoData.effect.play }}</div>
                </div>

                <div class="data-item">
                    <div class="item-label">
                        <i class="iconfont">&#xe70a;</i>
                        <span>消耗</span>
                    </div>

                    <div class="item-value">{{ videoData.effect.consume }}</div>
                </div>

                <div class="data-item">
                    <div class="item-label">
                        <i class="iconfont" style="font-size: 15px">&#xe624;</i>
                        <span>私信量</span>

                        <i class="iconfont question" @click="handleCommentInfo">&#xe603;</i>
                    </div>

                    <div class="item-value">{{ videoData.effect.comment }}<i class="el-icon-arrow-right"></i></div>
                </div>

                <div class="data-item">
                    <div class="item-label">
                        <i class="iconfont">&#xe85c;</i>
                        <span>实时数据</span>
                    </div>
                </div>
            </div>

            <!-- 互动数据 -->
            <div class="effect-interactive">
                <div class="interactive-header">互动数据</div>

                <div class="interactive-box">
                    <div class="interactive-item">
                        <div class="item-label">点赞量</div>
                        <div class="item-value">{{ videoData.effect.digg }}</div>
                    </div>

                    <div class="interactive-item">
                        <div class="item-label">评论量</div>
                        <div class="item-value">{{ videoData.effect.comment }}</div>
                    </div>

                    <div class="interactive-item">
                        <div class="item-label">分享量</div>
                        <div class="item-value">{{ videoData.effect.share }}</div>
                    </div>

                    <div class="interactive-item">
                        <div class="item-label">主页浏览量</div>
                        <div class="item-value">{{ videoData.effect.home }}</div>
                    </div>

                    <div class="interactive-item">
                        <div class="item-label">粉丝量</div>
                        <div class="item-value">{{ videoData.effect.fan }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 内容分析 -->
        <div class="delivery-detail_content-analysis delivery-item">
            <div class="item-header">内容分析<i class="iconfont" @click="handleContentAnalysisInfo">&#xe603;</i></div>

            <!-- 概述 -->
            <div class="content-analysis_overview">
                <div class="overview-label">以下指标越高，通常代表内容质量越好，投放DOU+效果也越好</div>

                <div class="overview-box">
                    <div class="overview-item">
                        <div class="item-value">{{ videoData.content_analysis.completion_rate }}%</div>
                        <div class="item-label"><i class="el-icon-caret-right"></i>5秒完播率</div>
                    </div>

                    <div class="overview-item">
                        <div class="item-value">{{ videoData.content_analysis.digg_rate }}%</div>
                        <div class="item-label"><i class="iconfont">&#xe85c;</i>点赞率</div>
                    </div>
                </div>
            </div>

            <div class="content-analysis_time">
                <div class="time-label">互动时间分布</div>

                <div class="time-check">
                    <div
                        :class="['check-item', { 'is-check': item.key === currentInteraction }]"
                        v-for="item in interactionOption"
                        :key="item.key"
                        @click="handleInteraction(item)"
                    >
                        {{ item.label }}
                    </div>
                </div>

                <div class="time-chart" ref="timeChartRef"></div>
            </div>
        </div>

        <!-- 观众画像 -->
        <div class="delivery-detail_portrait delivery-item">
            <div class="item-header">观众画像<i class="iconfont" @click="handlePortraitInfo">&#xe603;</i></div>

            <!-- 性别分布 -->
            <div class="portrait-sex portrait-item">
                <div class="portrait-item-header">性别分布</div>

                <div class="sex-box">
                    <div class="sex-item">
                        <div class="sex-item_left">
                            <div class="left-value">{{ videoData.portrait.sex.male }}%</div>
                            <div class="left-label">男性</div>
                        </div>

                        <div class="sex-item_right">
                            <img src="@/assets/images/training/male-icon.png" alt="" />
                        </div>
                    </div>

                    <div class="sex-item">
                        <div class="sex-item_left">
                            <div class="left-value">{{ videoData.portrait.sex.female }}%</div>
                            <div class="left-label">女性</div>
                        </div>

                        <div class="sex-item_right">
                            <img src="@/assets/images/training/female-icon.png" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- 年龄分布 -->
            <div class="portrait-age portrait-item">
                <div class="portrait-item-header">年龄分布</div>

                <div class="portrait-progress" v-for="(item, index) in videoData.portrait.age" :key="index">
                    <div class="portrait-progress_value" :style="{ width: `${item.value}%` }"></div>
                    <div class="portrait-progress_label">{{ item.label }}</div>
                    <div class="portrait-progress_value-label">{{ item.value }}%</div>
                </div>
            </div>

            <!-- 年龄分布 -->
            <div class="portrait-area portrait-item">
                <div class="portrait-item-header">地域分布<i class="iconfont" @click="handlePortraitAreaInfo">&#xe603;</i></div>

                <div class="portrait-progress" v-for="(item, index) in videoData.portrait.area" :key="index">
                    <div class="portrait-progress_value" :style="{ width: `${item.value}%` }"></div>
                    <div class="portrait-progress_label">{{ item.label }}</div>
                    <div class="portrait-progress_value-label">{{ item.value }}%</div>
                </div>
            </div>

            <!-- 八大人群占比 -->
            <div class="portrait-person portrait-item">
                <div class="portrait-item-header">八大人群占比<i class="iconfont" @click="handlePortraitPersonInfo">&#xe603;</i></div>

                <div class="portrait-progress" v-for="(item, index) in videoData.portrait.person" :key="index">
                    <div class="portrait-progress_value" :style="{ width: `${item.value}%` }"></div>
                    <div class="portrait-progress_label">{{ item.label }}</div>
                    <div class="portrait-progress_value-label">{{ item.value }}%</div>
                </div>
            </div>

            <!-- 人群细分占比 -->
            <div class="portrait-person-detail portrait-item">
                <div class="portrait-item-header">人群细分占比</div>

                <div class="person-detail-box">
                    <div class="person-detail-chart" ref="personDetailChartRef"></div>

                    <div class="person-detail-list">
                        <div class="person-detail-item" v-for="(item, index) in videoData.portrait.person_detail" :key="index">
                            <div class="item-value" :style="{ color: `${item.color}` }">{{ item.value }}%</div>
                            <div class="item-label">{{ item.name }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 兴趣分布 -->
            <div class="portrait-interest portrait-item">
                <div class="portrait-item-header">兴趣分布</div>

                <div class="interest-box">
                    <div class="interest-item" v-for="item in videoData.portrait.interest" :key="item">
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import videoJson from "@/utils/training-data/video.json";

export default {
    name: "DeliveryDetail",
    data() {
        return {
            expandDetail: false,
            videoData: videoJson.find((item) => item.type === Number(this.$route.query.type)),

            interactionOption: [
                { label: "点赞", key: "digg_data" },
                { label: "评论", key: "comment_data" },
                { label: "关注", key: "follow_data" },
                { label: "分享", key: "share_data" },
                { label: "主页浏览", key: "home_data" },
            ],
            currentInteraction: "digg_data",
        };
    },
    computed: {
        getDateLabel() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    },
    mounted() {
        this.setTimeChart(); // 设置互动时间分布图表
        this.setPersonDetailChart(); // 设置人群细分占比
    },
    methods: {
        getImgSrc(name) {
            if (!name) return "";

            return require(`@/assets/images/training/${name}`);
        },

        // 推广效果提示
        handleEffectInfo() {
            const title = "推广效果";
            const message1 =
                "1.订单数据仅统计由投放获得的增量数据，不包括自然流量，同时由于用户重复播放、取消点赞、删除评论或评论不符合平台规范等原因，会出现数据与视频播放页不一致的情况";
            const message2 = "2.数据可能会有延迟，请稍后查看，数据延迟在1小时内";

            this.$emit("show-info", title, [message1, message2], 5);
        },

        // 私信量提示
        handleCommentInfo() {
            const title = "私信量";
            const message = "私信量包含投放过程中获得的私信、表单信息、电话等所有线索数据";

            this.$emit("show-info", title, message, 5);
        },

        // 内容分析
        handleContentAnalysisInfo() {
            const title = "内容分析";
            const message =
                "仅统计投放获得的数据，不含自然流量。「5s完播率」：时长超过5s的播放次数/总播放次数，仅支持分析5s以上的视频；「点赞率」：点赞量/播放量；「播放时长分布」：统计播放过程中持续观看的用户比例，第n秒的数据代表播放至n秒的用户数/总播放用户数；「互动时间分布」：统计播放过程中每一秒的互动分布，第n秒的数据代表第n秒互动量/总互动量";

            this.$emit("show-info", title, message, 5);
        },

        // 观众画像提示
        handlePortraitInfo() {
            const title = "观众画像";
            const message = "以下是播放了此作品的人群的特征";

            this.$emit("show-info", title, message, 5);
        },

        // 观众画像地域提示
        handlePortraitAreaInfo() {
            const title = "地域分布";
            const message = "按照占比高低，仅展示排名靠前的地域";

            this.$emit("show-info", title, message, 5);
        },

        // 观众画像-八大人群占比
        handlePortraitPersonInfo() {
            const title = "八大人群占比";
            const message =
                "八大人群标签基于性别、年龄、城市级别、消费水平等信息，将用户划分为彼此互斥的8种类型，可以覆盖绝大多数活跃用户。因无法全量覆盖，可能会与受众报表披露的性别、年龄、城市级别信息存在一定差异。";

            this.$emit("show-info", title, message, 5);
        },

        // 切换互动时间分布item
        handleInteraction(item) {
            this.currentInteraction = item.key;

            this.setTimeChart();
        },

        setTimeChart() {
            if (!this.$refs.timeChartRef) return;

            const data = this.videoData.content_analysis[this.currentInteraction];

            const chart = this.$echarts.init(this.$refs.timeChartRef);

            const options = {
                grid: {
                    top: 20,
                    left: 40,
                    bottom: 20,
                    right: 15,
                },
                tooltip: {
                    trigger: "axis",
                    borderWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    extraCssText: "box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.3)",
                    textStyle: {
                        color: "#323233",
                    },
                    formatter: function(params) {
                        const value = params[0];

                        return `
                            <div class="time-tooltip">
                                <div class="time-label">${value.axisValue}</div>

                                <div class="time-value">
                                    <div class="icon">
                                        <i></i>占比：
                                    </div>
                                    
                                    <span>${value.data}%</span>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false, // 避免额外间隙
                    data: data.x,
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            type: "dashed",
                            color: "#999999",
                        },
                    },
                    axisLabel: {
                        interval: 0,

                        formatter: function(value, index) {
                            if (index == 0 || index == data.x.length - 1) {
                                return value;
                            } else {
                                return "";
                            }
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#999999",
                        formatter: function(value, index) {
                            return value + "%";
                        },
                    },
                },
                series: [
                    {
                        data: data.y,
                        type: "line",
                        showSymbol: false,
                        smooth: true,
                        lineStyle: {
                            color: "#f64e24",
                        },
                        symbol: "circle",
                        itemStyle: {
                            color: "#f64e24", // 数据点颜色（如蓝色）
                            borderWidth: 0, // 边框宽度
                        },
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#fae5d9", // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "#ffffff", // 100% 处的颜色
                                    },
                                ],
                                global: false, // 缺省为 false
                            },
                        },
                    },
                ],
            };

            chart.setOption(options);
        },

        setPersonDetailChart() {
            if (!this.$refs.personDetailChartRef) return;

            const data = this.videoData.portrait.person_detail;

            const chart = this.$echarts.init(this.$refs.personDetailChartRef);

            const options = {
                tooltip: {
                    trigger: "item",
                    borderWidth: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    extraCssText: "box-shadow: 0px 2px 5px 1px rgba(0,0,0,0.3)",
                    textStyle: {
                        color: "#323233",
                    },
                },
                color: data.map((item) => item.color),
                series: [
                    {
                        name: "人群细分占比",
                        type: "pie",
                        radius: ["50%", "100%"],
                        avoidLabelOverlap: false,
                        padAngle: data.length,
                        label: {
                            show: false,
                            position: "center",
                        },
                        labelLine: {
                            show: false,
                        },
                        data: data,
                        hoverAnimation: false,
                    },
                ],
            };

            chart.setOption(options);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .time-tooltip {
    width: 130px;
    height: 60px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 12px;
    gap: 6px;

    .time-value {
        display: flex;
        justify-content: space-between;
        width: 100%;

        i {
            width: 8px;
            height: 8px;
            background-color: #f64e24;
            border-radius: 50%;
            display: inline-block;
            margin-right: 6px;
        }
    }
}

.delivery-detail {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    font-family: PingFang-FC;
    color: #323233;

    &_header {
        img {
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 6px;
        }
    }

    &_result {
        margin-top: 8px;
        padding: 12px;
        background-color: #ffffff;
        border-radius: 6px;

        .result-icon {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 12px;

            img {
                width: 16px;
                height: 16px;
                object-fit: cover;
                margin: 0;
                padding: 0;
            }

            span {
                line-height: 16px;
                font-size: 16px;
            }
        }

        .result-desc {
            color: #999999;
            font-size: 12px;
        }
    }

    .delivery-item {
        margin-top: 12px;
        padding: 12px;
        background-color: #ffffff;
        border-radius: 6px;

        .item-header {
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 12px;
            display: flex;
            align-items: center;
            gap: 6px;

            .iconfont {
                font-size: 16px;
                line-height: 16px;
                cursor: pointer;
            }
        }
    }

    &_content {
        .content-video {
            display: flex;
            gap: 10px;
            margin-bottom: 20px;

            .video-img {
                width: 64px;
                height: 64px;
                object-fit: cover;
                border-radius: 6px;
            }

            .video-info {
                width: calc(100% - 70px);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                font-size: 14px;

                .info-title {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; /* 限制最多显示2行 */
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word; /* 避免长单词溢出 */
                }

                .info-user {
                    color: #999999;
                }
            }
        }

        .content-detail {
            .detail-item {
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;

                .item-label {
                    flex-shrink: 0;
                }

                .item-value {
                    flex-shrink: 0;
                    color: #999999;
                }
            }
        }

        .content-expand {
            display: flex;
            justify-content: center;

            .expand-button {
                color: #999999;
                cursor: pointer;

                .el-icon {
                    margin-left: 4px;
                }
            }
        }
    }

    &_effect {
        .effect-data {
            .data-item {
                display: flex;
                justify-content: space-between;
                margin-top: 16px;
                color: #333333;

                .item-label {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    line-height: 16px;

                    .iconfont {
                        color: #fc2b55;
                        font-size: 18px;
                        width: 16px;
                        height: 16px;
                        line-height: 16px;
                        text-align: center;

                        &.question {
                            color: #999999;
                            cursor: pointer;
                            font-size: 14px;
                        }
                    }
                }

                .item-value {
                    font-weight: 600;
                }
            }
        }

        .effect-interactive {
            margin-top: 16px;

            .interactive-header {
                font-size: 14px;
            }

            .interactive-box {
                margin-top: 16px;
                background-color: #fdfdfd;
                border-radius: 8px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;

                .interactive-item {
                    flex-shrink: 0;
                    width: calc(100% / 3);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    flex-direction: column;
                    height: 75px;
                    color: #333333;

                    .item-label {
                        color: #999999;
                        font-size: 14px;
                    }

                    .item-value {
                        font-size: 18px;
                        font-weight: 600;
                    }
                }
            }
        }
    }

    &_content-analysis {
        margin-top: 12px;

        .content-analysis_overview {
            .overview-label {
                font-size: 12px;
                color: #999999;
            }

            .overview-box {
                margin-top: 12px;
                display: flex;
                gap: 6px;

                .overview-item {
                    width: calc((100% - 10px) / 2);
                    flex-shrink: 0;
                    background-color: #f8f8f8;
                    border-radius: 4px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    color: #333333;
                    height: 100px;

                    .item-label {
                        color: #999999;

                        .iconfont {
                            line-height: 14px;
                            font-size: 14px;
                        }
                    }

                    .item-value {
                        font-size: 20px;
                        font-weight: 600;
                    }
                }
            }
        }

        .content-analysis_time {
            margin-top: 12px;

            .time-label {
                font-size: 16px;
            }

            .time-check {
                font-size: 13px;
                color: #323233;
                margin-top: 12px;
                display: flex;
                align-items: center;
                gap: 6px;

                .check-item {
                    padding: 0 6px 10px 6px;
                    position: relative;
                    text-align: center;
                    cursor: pointer;

                    &.is-check {
                        color: #333333;
                        font-weight: 600;

                        &::before {
                            content: "";
                            position: absolute;
                            width: 100%;
                            height: 3px;
                            bottom: 0;
                            left: 0;
                            background-color: #333333;
                            border-radius: 3px;
                        }
                    }
                }
            }

            .time-chart {
                // margin-top: 16px;
                height: 190px;
                // background-color: rgba(0, 0, 0, 0.5);
                // border: 1px solid rgba(0, 0, 0, 0.5);
            }
        }
    }

    &_portrait {
        .portrait-item {
            margin-top: 12px;

            .portrait-item-header {
                font-size: 14px;
                margin-bottom: 12px;

                .iconfont {
                    font-size: 14px;
                    color: #999999;
                    cursor: pointer;
                    margin-left: 4px;
                }
            }
        }

        .portrait-sex {
            .sex-box {
                display: flex;
                gap: 10px;

                .sex-item {
                    width: calc((100% - 10px) / 2);
                    flex-shrink: 0;
                    background-color: #f8f8f8;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border-radius: 6px;
                    height: 70px;
                    box-sizing: border-box;
                    padding-inline: 16px;

                    &_left {
                        .left-value {
                            font-weight: 600;
                            font-size: 20px;
                        }

                        .left-label {
                            color: #999999;
                        }
                    }

                    img {
                        width: 30px;
                    }
                }
            }
        }

        .portrait-progress {
            height: 30px;
            background-color: #f8f8f8;
            position: relative;
            border-radius: 4px;
            overflow: hidden;

            &:not(.portrait-progress:first-child) {
                margin-top: 12px;
            }

            &_value {
                height: 100%;
                background-color: #fdd5dd;
            }

            &_label,
            &_value-label {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
            }

            &_label {
                left: 10px;
            }

            &_value-label {
                right: 10px;
                font-weight: 600;
            }
        }

        .portrait-person-detail {
            .person-detail-box {
                .person-detail-chart {
                    height: 140px;
                    // border: 1px solid rgba(0, 0, 0, 0.5);
                }

                .person-detail-list {
                    margin-top: 12px;
                    display: flex;
                    flex-wrap: wrap;
                    row-gap: 10px;

                    .person-detail-item {
                        width: calc(100% / 3);
                        display: flex;
                        flex-direction: column;
                        align-items: center;

                        .item-value {
                            font-size: 20px;
                            font-weight: 600;
                        }

                        .item-label {
                            color: #999999;
                        }
                    }
                }
            }
        }

        .portrait-interest {
            .interest-box {
                display: flex;
                gap: 10px;
                flex-wrap: wrap;

                .interest-item {
                    width: calc((100% - 20px) / 3);
                    background-color: #fdd5dd;
                    border-radius: 4px;
                    flex-shrink: 0;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                }
            }
        }
    }
}
</style>
